export interface FabrixCoreApi {
    
}


export interface FabrixItemProperties {
    /** Name of the item */
    name?: string;
    /** Description of the item.*/
    description?: string;
    /** Any user defined tags */
    tags?: string[];
    /** The color of the item. */
    color?: string;
    /** Custom props bucket */
    children?: any[];

}

export const initFabrixItemProperties = () => {
    let item: FabrixItemProperties = {
        name: "",
        description: "",
    }
    return item;
}